export default __webpack_public_path__ + "static/media/plusDark.4306a2a6.svg";